<template>
    <div id="print" class="course_main" :style="{'background-color': '#275ba9'}">
        <div class="back_nav" @click="goBack"><img src="../../assets/back_nav.png"/></div>

        <audio v-show="false" :src="audioUrl" id="musicMp3" />

        <div class="word_main">
            <!-- 本课词汇 -->
            <div class="word_title" v-if="listCore != null && listCore.length > 0">
                <span>本课词汇 {{listCore.length}}</span>
            </div>

            <div class="word_card_list" v-if="listCore != null && listCore.length > 0">
                <div class="word_card_item" v-for="(wordCard, index) in listCore" :key="index" @click="wordClick(index, 1)">
                    <div class="before" :style="{transform:wordCard.status === 0 ? 'rotateY(-180deg)':''}">
                        <img class="lazy_img" v-lazy="$qiNiuDomainBase + wordCard.picture" alt="" />
                    </div>
                    <div class="chinese_trans after" :style="{transform:wordCard.status === 0 ? 'rotateY(-360deg)':''}">
                        {{wordCard.chineseAndEnglishInterpretation}}
                    </div>
                    <div class="word">{{wordCard.word}}</div>
                </div>
            </div>

            <!-- 已学词汇 -->
            <div class="word_title margin_top40" v-if="listCommon != null && listCommon.length > 0">
                <span>已学词汇 {{listCommon.length}}</span>
            </div>

            <div class="word_card_list" v-if="listCommon != null && listCommon.length > 0">
                <div class="word_card_item" v-for="(wordCard, index) in listCommon" :key="index" @click="wordClick(index, 2)">
                    <div class="before" :style="{transform:wordCard.status === 0 ? 'rotateY(-180deg)':''}">
                        <img class="lazy_img" v-lazy="$qiNiuDomainBase + wordCard.picture" alt="" />
                    </div>
                    <div class="chinese_trans after" :style="{transform:wordCard.status === 0 ? 'rotateY(-360deg)':''}">
                        {{wordCard.chineseAndEnglishInterpretation}}
                    </div>
                    <div class="word">{{wordCard.word}}</div>
                </div>
            </div>

            <div class="margin_top40"></div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import Vue from "vue";

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        data() {
            return {
                lessonId: 0,
                listCore: [],
                listCommon: [],
                audioUrl: '',
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            showStatusWhite:function (status) {
                let that = this;

                if (that.isAppIos()) {
                    document.location = "readingclubapp:changeStatusStyle:" + status;
                }

                if (that.isAppAndroid()) {
                    window.note.changeStatusStyle(status);
                }
            },
            wordClick: function (index, type) {
                let that = this;

                // 设置翻转状态
                let wordCard = type === 1 ? that.listCore[index] : that.listCommon[index];
                wordCard.status = wordCard.status === 0 ? 1 : 0;

                Vue.set(type === 1 ? that.listCore : that.listCommon, index, wordCard);

                // 播放音频
                that.audioUrl = that.$qiNiuDomainBase + wordCard.audio;
                const musicMp3 = document.getElementById('musicMp3');
                musicMp3.src = that.audioUrl;

                setTimeout(() => {
                    let playPromise = musicMp3.play();

                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                        }).catch((e) => {
                            let vError = JSON.stringify(e);

                            if (!that.isEmpty(vError) && vError !== "{}") {
                                window.console.log("播放失败:playAudio:" + vError);
                            }
                        });
                    }
                }, 50);

            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(this.$route.query.lessonId);
            let url = "englishProgram/getWordCardInLesson3/" + vLessonId;

            this.$axios.get(url).then((response) => {
                let vVocabulary = response.data;
                that.listCore = vVocabulary.coreWordList;
                that.listCommon = vVocabulary.commonWordList;
                that.hideStatusAndStopAudio();

                setTimeout(() => {
                    transformView();
                }, 200);
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.showStatusWhite(0);
            });
        },
        beforeRouteLeave(to, form, next) {
            this.showStatusWhite(1);
            next();
        },
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    img { pointer-events: none; }

    .course_main {
        position: relative;
        width: 100vmax;
        height: 100vmin;
        -webkit-user-select:none;
        -khtml-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
    }
    .back_nav {
        position: fixed;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }

    ::-webkit-scrollbar {
        display: none;
    }

    .course_main .word_main {
        position: absolute;
        width: calc(100vmax - 2px);
        height: calc(100vmin + 1px);
        left: 1px;
        overflow: scroll;
    }
    .word_title {
        margin-top: 15px;
        margin-bottom: 10px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #ffffff;  /* #FEB800; */
        font-size: 18px;
    }
    .margin_top40 {
        margin-top: 40px;
    }

    .word_card_list {
        width: 420px;
        display: flex;
        flex-wrap: wrap;
        margin-left: calc((100vmax - 418px)/2);
    }
    .word_card_list .word_card_item {
        width: 120px;
        height: 160px;
        background-color: #dcdcdc;
        margin-left: 10px;
        margin-right: 10px;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        margin-bottom: 20px;
        position: relative;
    }

    .word_card_item img {
        width: 110px;
        height: 110px;
        margin: 5px 5px 0 5px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        font-size: 0;
    }
    .word_card_item .chinese_trans {
        width: 110px;
        height: 110px;
        background-color: white;
        margin: 5px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
    .word_card_item .word {
        width: 120px;
        height: 40px;
        position: absolute;
        bottom: 0;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .before {
        width: 100%;
        height: 100%;
        position: absolute;
        top:0;
        left: 0;
        backface-visibility: hidden;
        transition: 0.5s;
    }
    .after {
        width: 100%;
        height: 100%;
        position: absolute;
        top:0;
        left: 0;
        transform: rotateY(-180deg);
        backface-visibility: hidden;
        transition: 0.5s;
    }

</style>
